
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.footer:not(.mobile){
  display:flex;
  flex-direction:column;
  margin:0;
  flex-wrap:wrap;
  width:100%;
  height:100%;
}

.footer.mobile{
  margin:2.75rem var(--spacing-04) var(--spacing-08) var(--spacing-04);
  align-items:start;
  display:flex;
  flex-direction:column;
}

.footer-top{
  display:flex;
  flex-direction:row;
  padding-bottom:var(--spacing-08);
  justify-content:space-between;
  gap:var(--spacing-08);
  flex-flow:row wrap;
}

@media (min-width: 1024px){

.footer-top{
    padding-bottom:var(--spacing-12);
    flex-flow:row nowrap
}
  }

.mobile .footer-top{
  flex-direction:column;
  gap:var(--spacing-08);
}

.footer-navigation{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-08);
  width:100%;
  flex-grow:1;
}

.footer-hr{
  width:100%;
  height:1px;
  color:var(--color-neutral-lighter);
  margin:0px;
}

.footer-sidebar{
  display:flex;
  flex-grow:1;
  flex-direction:column;
  column-gap:var(--spacing-08);
  row-gap:var(--spacing-04);
  margin-bottom:0.938rem;
  width:20%;
}

@media (min-width: 768px){

.footer-sidebar{
    row-gap:var(--spacing-12)
}
  }

@media (min-width: 1024px){

.footer-sidebar{
    row-gap:var(--spacing-04)
}
  }

.footer-bottom{
  --sic-text-color:var(--color-neutral-dark);
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:var(--spacing-08);
  margin-top:var(--spacing-08);
}

.footer.mobile .footer-bottom{
    flex-direction:column;
    gap:var(--spacing-05);
  }
`;